<div class="container-fluid">

  <!-- Heading -->
  <div class="row pt-4 pl-4"
       style="font-size: 22px !important; font-weight: 400; color: #424242;">
    <h5>
      <i class="fa fa-circle" style="color:#800000"></i>
      &nbsp;Reports
    </h5>
  </div>

  <div class="container">
    <div class="modal-body">

      <!-- ✅ SINGLE ROW (LEFT ALIGNED) -->
      <div class="row g-4">

        <!-- ================= HR REPORTS ================= -->
        <div class="col-12 col-sm-6 col-lg-4"
             *ngIf="hasAccess('HR Reports')">

          <div class="card shadow text-center">
            <div class="card-body">

              <div ngbDropdown class="d-inline-block w-100">
                <button type="button"
                        class="btn btnStyleClass w-100"
                        ngbDropdownToggle>
                  HR Reports
                </button>

                <div ngbDropdownMenu class="w-100">

                  <button ngbDropdownItem routerLink="/dashboard/diary-details">Diary Details</button>
                  <button ngbDropdownItem routerLink="/dashboard/penalty-summary-report">Penalty Summary</button>
                  <button ngbDropdownItem routerLink="/dashboard/article-availability-report">Article Availability</button>
                  <button ngbDropdownItem routerLink="/dashboard/article-one-sixth-report">Article 1/6th Report</button>
                  <button ngbDropdownItem routerLink="/dashboard/hr-my-leaves">Employee Leave Summary</button>
                  <button ngbDropdownItem routerLink="/dashboard/empanelment-report">Empanelment Report</button>
                  <button ngbDropdownItem routerLink="/dashboard/overtime-report">Overtime Report</button>
                  <button ngbDropdownItem routerLink="/dashboard/article-debit-credit-hours">Article Debit Credit Report</button>
                  <button ngbDropdownItem routerLink="/dashboard/salary-slip">Salary Slip</button>
                  <button ngbDropdownItem routerLink="/dashboard/physical-verification-report">Asset Physical Verification</button>
                  <button ngbDropdownItem routerLink="/dashboard/popup-confirmation-report">Asset Pop-up Confirmations</button>
                  <button ngbDropdownItem routerLink="/dashboard/transfer-history-report">Asset History Report</button>
                  <button ngbDropdownItem routerLink="/dashboard/manage-announcement-history">Announcement History</button>
                  <button ngbDropdownItem routerLink="/dashboard/monthly-new-joinee-report">Monthly New Joinee Report</button>
                  <button ngbDropdownItem routerLink="/dashboard/monthly-left-employee-report">Monthly Left Employee Report</button>
                  <button ngbDropdownItem routerLink="/dashboard/monthly-conveyance-detail-report">Monthly Conveyance Details</button>
                  <button ngbDropdownItem routerLink="/dashboard/exit-form-summary">Exit Form Summary</button>

                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- ================= ACCOUNT REPORTS ================= -->
        <div class="col-12 col-sm-6 col-lg-4"
             *ngIf="hasAccess('Account Reports')">

          <div class="card shadow text-center">
            <div class="card-body">

              <div ngbDropdown class="d-inline-block w-100">
                <button type="button"
                        class="btn btnStyleClass w-100"
                        ngbDropdownToggle>
                  Account Reports
                </button>

                <div ngbDropdownMenu class="w-100">

                  <button *ngIf="isPartner || isAccountVertical" ngbDropdownItem routerLink="/dashboard/monthly-conveyance-detail-report">Monthly Conveyance Details</button>
                  <button *ngIf="isPartner || isAccountVertical" ngbDropdownItem routerLink="/dashboard/monthly-conveyance-report">Monthly Conveyance</button>
                  <button *ngIf="isPartner || isAccountVertical || isHrVertical" ngbDropdownItem routerLink="/dashboard/salary-report">Employee Salary Report</button>
                  <button *ngIf="isPartner || isAccountVertical" ngbDropdownItem routerLink="/dashboard/client-conveyance-assignment">Client Conveyance Assignment</button>
                  <button *ngIf="isPartner || isAccountVertical" ngbDropdownItem routerLink="/dashboard/penalty-summary-report">Penalty Summary</button>
                  <button *ngIf="isPartner || isAccountVertical"ngbDropdownItem routerLink="/dashboard/stipend-report">Article Stipend</button>
                  <button *ngIf="isPartner || isAccountVertical" ngbDropdownItem routerLink="/dashboard/bank-payment">Bank Payment Report</button>
                  <button *ngIf="isPartner || isAccountVertical || isHrVertical" ngbDropdownItem routerLink="/dashboard/salary-slip">Salary Slip</button>
                  <button *ngIf="isPartner || isAccountVertical || isHrVertical" ngbDropdownItem routerLink="/dashboard/annual-salary-report">Annual Salary Report</button>
                  <button *ngIf="isPartner || isAccountVertical" ngbDropdownItem routerLink="/dashboard/annual-stipend-report">Annual Stipend Report</button>
                  <button *ngIf="isPartner || isAccountVertical" ngbDropdownItem routerLink="/dashboard/expense-reimbursement-report">Expense Reimbursement Report</button>

                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- ================= PARTNER REPORTS ================= -->
        <div class="col-12 col-sm-6 col-lg-4"
             *ngIf="hasAccess('Partner Reports')">

          <div class="card shadow text-center">
            <div class="card-body">

              <div ngbDropdown class="d-inline-block w-100">
                <button type="button"
                        class="btn btnStyleClass w-100"
                        ngbDropdownToggle>
                  Partner Reports
                </button>

                <div ngbDropdownMenu class="w-100">

                  <button ngbDropdownItem routerLink="/dashboard/budget-report">Budget</button>
                  <button ngbDropdownItem routerLink="/dashboard/overtime-report">Overtime Report</button>
                  <button ngbDropdownItem routerLink="/dashboard/all-independence-declaration">Independence Declaration</button>
                  <button ngbDropdownItem routerLink="/dashboard/budget-vs-actual-cost">Variance Report</button>
                  <button ngbDropdownItem routerLink="/dashboard/variance-report-excel">Variance Report Summary</button>
                  <button ngbDropdownItem routerLink="/dashboard/article-debit-credit-hours">Article Debit Credit Report</button>
                  <button ngbDropdownItem routerLink="/dashboard/actual-task-report">Actual Task Summary Report</button>
                  <button ngbDropdownItem routerLink="/dashboard/manage-announcement-history">Announcement History</button>
                  <button ngbDropdownItem routerLink="/dashboard/diary-details-client-wise">Diary Report - Client Wise</button>
                  <button ngbDropdownItem routerLink="/dashboard/mis-report">MIS Report</button>

                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
      <!-- ✅ END ROW -->

    </div>
  </div>
</div>